import { ContentStateInterface, TenantDocuments } from '../../@types/types'
import { tenantDocumentsLanguages } from './TenantDocuments'
import { ChipGroupFeature } from '../../components/common/inputs/chipsGroup/ChipsGroup'

export const getTenantDocuments = (
  insertionData: ContentStateInterface,
  tenantDocuments: (keyof TenantDocuments)[]
): ChipGroupFeature[] => {
  const documents = {
    selfReport: insertionData.selfReport,
    solvency: insertionData.solvency,
    rental: insertionData.rental,
    identification: insertionData.identification,
    income: insertionData.income,
  } as Record<string, boolean>
  return tenantDocuments.map((property) => ({
    property,
    value: documents[property] ?? false,
    defaultTranslationText: tenantDocumentsLanguages[property as keyof TenantDocuments].translation,
  }))
}
